// extracted by mini-css-extract-plugin
export var holder = "SimpleBlogLatestSectionSearch-module--holder--d12a8";
export var resultEntry = "SimpleBlogLatestSectionSearch-module--resultEntry--44b07";
export var resultEntryLink = "SimpleBlogLatestSectionSearch-module--resultEntryLink--88328";
export var resultEntryList = "SimpleBlogLatestSectionSearch-module--resultEntryList--d9d83";
export var resultEntrySynopsis = "SimpleBlogLatestSectionSearch-module--resultEntrySynopsis--cdcba";
export var resultEntryTitle = "SimpleBlogLatestSectionSearch-module--resultEntryTitle--884a0";
export var results = "SimpleBlogLatestSectionSearch-module--results--2353a";
export var resultsSeparator = "SimpleBlogLatestSectionSearch-module--resultsSeparator--678ad";
export var searchField = "SimpleBlogLatestSectionSearch-module--searchField--5e726";
export var spinnerActive = "SimpleBlogLatestSectionSearch-module--spinnerActive--ebd35";
export var spinnerInactive = "SimpleBlogLatestSectionSearch-module--spinnerInactive--fd85f";
export var toggle = "SimpleBlogLatestSectionSearch-module--toggle--3e995";
export var widget = "SimpleBlogLatestSectionSearch-module--widget--0b87a";
export var widgetInput = "SimpleBlogLatestSectionSearch-module--widgetInput--c0ba0";
export var wrapper = "SimpleBlogLatestSectionSearch-module--wrapper--be5b6";
export var wrapperOpen = "SimpleBlogLatestSectionSearch-module--wrapperOpen--481ef";